import React from 'react';
import AggregateProto from './aggregate-proto';

export default class AggregateMomentRange extends AggregateProto {

    min() {
        if (this.data.length === 0) return null;

        //data should be array of moment ranges
        return _.chain(this.data)
            .minBy(item=>item.start.format('x'))
            .value().start;
    }

    max() {
        if (this.data.length === 0) return null;

        //data should be array of moment ranges
        return _.chain(this.data)
            .maxBy(item=>item.end.format('x'))
            .value().end;
    }

    range() {
        if (this.data.length === 0) return null;

        //data should be array of moment ranges
        let min = this.data[0].start, max = this.data[0].end;
        _.map(this.data, momentRange=> {
            if (momentRange.start.isBefore(min)) min = momentRange.start;
            else if (momentRange.end.isAfter(max)) max = momentRange.end;
        });

        return Moment.range(min, max);
    }
}